;(function () {
	const initSlider = (section) => {
		let slider
		const root =
			(document.currentScript && document.currentScript.parentElement) ||
			section ||
			document
		slider = root.querySelector('.blog__slider')

		if (!slider) {
			return
		}

		const parent = slider.parentElement || root
		const navigation = parent.querySelector('.blog__navigation')
		const pagination = parent.querySelector('.blog__pagination')
		const columns = Number(slider.dataset.columns)
		let columns1200 = columns == 4 ? columns - 1 : columns
		let columns990 = columns > 3 ? columns - 1 : columns
		let columns576 = columns > 2 ? columns990 - 1 : columns990

		const articlesSlider = new Swiper(slider, {
			slidesPerView: 1,
			spaceBetween: 24,
			mousewheel: {
				forceToAxis: true,
			},
			speed: 1000,
			navigation: navigation
				? {
						nextEl: navigation.querySelector('.swiper-button-next'),
						prevEl: navigation.querySelector('.swiper-button-prev'),
				  }
				: undefined,
			pagination: pagination
				? {
						el: pagination,
						type: 'bullets',
						clickable: true,
				  }
				: undefined,
			breakpoints: {
				576: {
					slidesPerView: columns576,
					slidesPerGroup: columns576,
				},
				990: {
					slidesPerView: columns990,
					slidesPerGroup: columns990,
				},
				1200: {
					slidesPerView: columns1200,
					slidesPerGroup: columns1200,
				},
				1360: {
					slidesPerView: columns,
					slidesPerGroup: columns,
				},
			},
		})
	}

	function bootFeaturedBlog() {
		initSlider()
	}

	if (window.themeSwiperReady) {
		window.themeSwiperReady.then(bootFeaturedBlog).catch(function () {})
	} else {
		bootFeaturedBlog()
	}

	document.addEventListener('shopify:section:load', function (section) {
		if (window.themeSwiperReady) {
			window.themeSwiperReady.then(function () {
				initSlider(section.target)
			}).catch(function () {})
		} else {
			initSlider(section.target)
		}
	})
})()
